<div *ngIf="reportType === 'briefly1'">
  <div class="container-fluid px-4" id="print-section">

    <!-- ===== HEADER TABLE ===== -->
    <table style="width: 100%; border-collapse: collapse; border: 1px solid black; background-color: #f8f9fa;">
      
      <!-- Main Header Row -->
      <tr>
        <th  style="border:none; font-size: 16px; font-weight: bold; text-align:center; padding:8px; border-bottom: 1px solid black;">
          हिंदुस्तान प्रकाशन संस्था 
        </th>
        <th  style="border:none; font-size: 18px; text-align:center; font-weight:bold; padding:8px; border-bottom: 1px solid black;">
          Book Credit Note Report
        </th>
        <th  style="border:none; font-size: 16px; text-align:right; padding:8px; border-bottom: 1px solid black;">
          दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
        </th>
      </tr>

      <!-- Sub Header Row -->
      <tr>
        <th  style="border:none; font-size: 16px; font-weight: bold; text-align:center; padding:8px;">
         विवेक पुस्तक प्रकाशन
        </th>
        <th  style="border:none; font-size: 16px; text-align:center; font-weight:bold; padding:8px;">
          All Briefly
        </th>
        <th  style="border:none; font-size: 16px; text-align:right; padding:8px;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

    </table>

    <!-- ===== MAIN DATA TABLE ===== -->
    <table class="table table-bordered table-sm w-100" style="border-collapse: collapse; border:1px solid black; margin-top: 0;">

      <!-- Column Headers -->
      <thead class="text-center align-middle">
        <tr style="font-weight:bold; background-color: #f1f1f1;">
          <th style="border:1px solid black; padding:8px; text-align:center;">Credit Note Date</th>
          <th style="border:1px solid black; padding:8px; text-align:center;">Credit Note No.</th>
          <th style="border:1px solid black; padding:8px; text-align:center;width:40%;">Book Seller Name</th>
          <th style="border:1px solid black; padding:8px; text-align:center;">Credit Amount</th>
        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody>
        <ng-container *ngFor="let office of groupedData">
          
          <!-- Office Representative Name Header -->
          <tr style="font-weight: bold;">
            <td colspan="4" style="border:1px solid black; padding:8px; text-align:center;">
              Office Representative: {{ office.office_rep_name }}
            </td>
          </tr>

          <!-- Loop through Representatives under this Office -->
          <ng-container *ngFor="let rep of office.representatives">
            
            <!-- Representative Name Header -->
            <tr >
              <td colspan="4" style="border:1px solid black; padding:8px; text-align:left; font-weight: bold;">
                Representative: {{ rep.rep_name }}
              </td>
            </tr>

            <!-- Data Rows for this Representative -->
            <tr *ngFor="let data of rep.records" style="text-align: center;">
              <td style="border:1px solid black; padding:8px; text-align:center; white-space: nowrap;">
                {{ data.crdtnote_date | date:'dd-MM-yyyy' }}
              </td>
              <td style="border:1px solid black; padding:8px; text-align:center; white-space: nowrap;">
                {{ data.crdtnote_no }}
              </td>
              <td style="border:1px solid black; padding:8px; text-align:left; white-space: nowrap;">
                {{ data.book_seller_name }}
              </td>
              <td style="border:1px solid black; padding:8px; text-align:right;">
                {{ data.crdtnote_total  }}
              </td>
            </tr>

            <!-- Representative Total Row -->
            <tr style="font-weight: bold;">
              <td colspan="3" style="border:1px solid black; text-align:right; padding:8px;">
                Total for Rep: {{ rep.rep_name }}
              </td>
              <td style="border:1px solid black; text-align:right; padding:8px;">
                {{ rep.rep_credit_total  }}
              </td>
            </tr>

          </ng-container>

          <!-- Office Representative Total Row -->
          <tr style="background-color: #f4b084; font-weight: bold;">
            <td colspan="3" style="border:1px solid black; text-align:right; padding:8px;">
              Total for Office Rep: {{ office.office_rep_name }}
            </td>
            <td style="border:1px solid black; text-align:right; padding:8px;">
              {{ office.office_credit_total  }}
            </td>
          </tr>

        </ng-container>
      </tbody>

      <!-- ================= FOOTER ================= -->
      <tfoot>
        <tr style="font-weight:bold; background-color: #c8753f;">
          <td colspan="3" style="border:1px solid black; text-align:right; padding:8px;">
            Grand Total:
          </td>
          <td style="border:1px solid black; text-align:right; padding:8px;">
            {{ TotalCreditNoteAmt  }}
          </td>
        </tr>
      </tfoot>

    </table>
  </div>

  <!-- Buttons -->
  <div class="noPrint d-flex justify-content-end gap-3 px-4 mb-4 mt-3">
    <button class="btn btn-primary" (click)="exportExcel('BookCreditNote_InDetail_Report')">Export</button>
    <button class="btn btn-primary" (click)="printPageA4()">Print</button>
    <button class="btn btn-secondary" mat-dialog-close>Close</button>
  </div>
</div>